import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function TravelInfo() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const travelDetails = [
    { label: 'Nearest Airport', value: 'Jaipur International Airport (Approx. 25 km | 45–60 minutes)' },
    { label: 'Nearest Railway Station', value: 'Jaipur Junction Railway Station (Approx. 22 km | 45 minutes)' },
    { label: 'Nearest Bus Stand', value: 'Sindhi Camp Bus Stand (Approx. 21 km)' },
    { label: 'Location Access', value: 'Accessible via Jamdoli on Jaipur–Agra Highway' }
  ];

  const cabServices = [
    'Uber – Available through app',
    'Ola – Available through app',
    'Local Radio Taxi – 0141-2380000'
  ];

  return (
    <div className="page-container">
      <PageCarousel />

      <section className="section-padding">
        <div className="container">

          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="section-title-header text-center mb-5">
                <h1 className="section-title">How to Reach LNMIIT</h1>
              </div>
            </div>
          </div>

          {/* Location Section */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10">
              <div className="p-4 shadow-sm bg-white" style={{borderRadius: '12px'}}>
                <h4 style={{color: '#70b60a'}}>Location</h4>
                <p>
                  LNMIIT's campus is situated in <strong>Rupa ki Nangal, via Jamdoli, Jaipur, Rajasthan</strong>.
                </p>
                <p>
                  <strong>Address:</strong><br/>
                  The LNM Institute of Information Technology,<br/>
                  Rupa ki Nangal, Post-Sumel, Via-Jamdoli,<br/>
                  Jaipur-302031, Rajasthan, INDIA
                </p>
              </div>
            </div>
          </div>

          {/* Transportation Section */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10">
              <div className="p-4 shadow-sm bg-white" style={{borderRadius: '12px'}}>
                <h4 style={{color: '#70b60a'}}>Transportation</h4>

                {/* Institute Bus Service - Added at the top of the section */}
                <div className="mb-4 p-3 rounded" style={{ backgroundColor: '#f8f9fa', borderLeft: '4px solid #70b60a' }}>
                  <strong>Institute Bus Service:</strong><br/>
                  Institute bus services are available to-and-from city as per the schedule given at:{' '}
                  <a 
                    href="https://lnmiit.ac.in/transportation/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={{ color: '#70b60a', fontWeight: '600' }}
                  >
                    https://lnmiit.ac.in/transportation/
                  </a>
                </div>

                {travelDetails.map((item, idx) => (
                  <p key={idx}>
                    <strong>{item.label}:</strong> {item.value}
                  </p>
                ))}

                <p>
                  Prepaid taxis, auto-rickshaws, and app-based cab services are readily available 
                  at the airport and railway station.
                </p>
              </div>
            </div>
          </div>

          {/* Cab Services Section */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10">
              <div className="p-4 shadow-sm bg-white" style={{borderRadius: '12px'}}>
                <h4 style={{color: '#70b60a'}}>Cab Services</h4>
                <ul>
                  {cabServices.map((cab, idx) => (
                    <li key={idx} style={{marginBottom: '8px'}}>{cab}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Google Map */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10">
              <div className="shadow-sm" style={{borderRadius: '12px', overflow: 'hidden'}}>
                <iframe
                  title="LNMIIT Jaipur Location"
                  style={{ width: '100%', height: '450px', border: '0' }}
                  src="https://www.google.com/maps?q=LNMIIT+Jaipur&output=embed"
                  allowFullScreen=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default TravelInfo;